"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UI_1 = require("~/components/UI");
const assets_1 = require("~/assets");
const CustomerItem_module_scss_1 = __importDefault(require("./CustomerItem.module.scss"));
function CustomerItem({ customer, selected, onSelect, options, onOptionClick }) {
    var _a;
    return (react_1.default.createElement("tr", { className: CustomerItem_module_scss_1.default.row, "data-selected": selected, onClick: () => onSelect(customer) },
        react_1.default.createElement("td", { className: CustomerItem_module_scss_1.default['row-item'] },
            customer.activeSpecialDiscount ? (react_1.default.createElement("img", { src: assets_1.svgQuoteListItemPrice, alt: "something", className: CustomerItem_module_scss_1.default.icon })) : null,
            customer.firstName),
        react_1.default.createElement("td", { className: CustomerItem_module_scss_1.default['row-item'] }, customer.lastName),
        react_1.default.createElement("td", { className: CustomerItem_module_scss_1.default['row-item'] }, (_a = customer.companyName) !== null && _a !== void 0 ? _a : '-'),
        react_1.default.createElement("td", { className: CustomerItem_module_scss_1.default['row-item'] },
            react_1.default.createElement(UI_1.Options, { options: options, placement: "left-center", onClick: onOptionClick }))));
}
exports.default = CustomerItem;
